module.exports = __webpack_public_path__ + "static/event-3-1f45723d24fbc9c43bed5f768d31c8f8.mp4";